import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import UserImage from "../../assets/user.png"
import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { FaPen } from 'react-icons/fa'

const UserProfile = () => {

    const userInfo = useSelector((state) => state.auth.user)
    const navigate = useNavigate()
    // console.log("profile_info:",userInfo)
    return (
        <div className="profile-page-container">
            <div className="profile-page-menu">
                <div className='user-details'>
                    <h2 className="content-header">Profile</h2>
                    <div className="userdata">
                        <img src={userInfo.user.profilePic ? userInfo.user.profilePic : UserImage} alt="" className="home-user-image" />
                        <h3 className="username">{userInfo?.user.firstname} {userInfo?.user.lastname}</h3>
                        <div className="profile-edit-btn" onClick={() => navigate(`/profile/edit`, { state: { user: userInfo } })}>
                            <button>  <FaPen /> Edit</button>
                        </div>
                    </div>
                    <div className="user-community">
                        <NavLink to="/profile/">
                            <p className="community">Posts</p>
                        </NavLink>
                        <NavLink to="/profile/friends">
                            <p className="community">{`Friends (${userInfo ? userInfo.user.friendsCount : 0})`}</p>
                        </NavLink>
                        <NavLink to="/profile/friend-requests">
                            <p className="community">{`Friends requests (${userInfo ? userInfo.user.receivedFriendRequests : 0})`}</p>
                        </NavLink>
                        <NavLink to="/profile/followers">
                            <p className="community">{`Followers (${userInfo ? userInfo.user.followers : 0})`}</p>
                        </NavLink>
                        <NavLink to="/profile/followings">
                            <p className="community">{`Followings (${userInfo ? userInfo.user.followings : 0})`}</p>
                        </NavLink>
                        <NavLink to="/chats">
                            <p className="community">{`Messages`}</p>
                        </NavLink>
                    </div>
                </div>
            </div>
            <div className="profile-page-content">
                <Outlet />
            </div>
        </div>
    )
}

export default UserProfile